import { render, staticRenderFns } from "./SwitchCell.vue?vue&type=template&id=5c387e08&scoped=true&"
import script from "./SwitchCell.vue?vue&type=script&lang=js&"
export * from "./SwitchCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c387e08",
  null
  
)

export default component.exports